import { Box, Typography, Avatar, Stack, Chip } from '@mui/material';

// Teilnehmer-Abschnitt (Zusagen oder Absagen) – parametrisiert über Farben/Texte.
function TeilnehmerListe({
    icon,
    title,
    teilnehmer,
    nutzerId,
    emptyText,
    chipColor,
    headerBorderColor,
    itemBg,
    activeBorderColor,
    avatarBg,
    avatarColor,
}) {
    return (
        <Box>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                mb: 1.5,
                pb: 0.5,
                borderBottom: `2px solid ${headerBorderColor}`,
            }}>
                {icon}
                <Typography variant="body2" color="#e0f2fe" sx={{ fontWeight: 600 }}>
                    {title}
                </Typography>
                <Chip
                    label={teilnehmer.length}
                    size="small"
                    sx={{
                        bgcolor: chipColor,
                        color: '#fff',
                        height: 20,
                        fontSize: '0.75rem',
                        fontWeight: 600
                    }}
                />
            </Box>
            {teilnehmer.length > 0 ? (
                <Stack spacing={0.5}>
                    {teilnehmer.map((t) => (
                        <Box
                            key={t.id}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.5,
                                p: 1,
                                bgcolor: itemBg,
                                borderRadius: '10px',
                                border: t.id === nutzerId ? `1px solid ${activeBorderColor}` : 'none'
                            }}
                        >
                            <Avatar sx={{
                                bgcolor: avatarBg,
                                width: 32,
                                height: 32,
                                fontSize: '0.9rem',
                                color: avatarColor
                            }}>
                                {t.name.charAt(0)}
                            </Avatar>
                            <Typography
                                variant="body2"
                                color="#e0f2fe"
                                sx={{
                                    flex: 1,
                                    fontWeight: t.id === nutzerId ? 600 : 400
                                }}
                            >
                                {t.name}
                                {t.id === nutzerId && ' (Du)'}
                            </Typography>
                        </Box>
                    ))}
                </Stack>
            ) : (
                <Box sx={{
                    textAlign: 'center',
                    py: 2,
                    color: '#93c5fd',
                    fontSize: '0.85rem'
                }}>
                    {emptyText}
                </Box>
            )}
        </Box>
    );
}

export default TeilnehmerListe;
